import { CustomsPingResult, CustomsPingResultApi } from '../types/ping';

export class CustomsPingMappers {
  public static fromApi(result: CustomsPingResultApi): CustomsPingResult {
    return {
      status: result ? 'success' : 'error',
    };
  }
}
